var e = class {
	get value() {
		return `oklch(${this.lightness} ${this.chroma} ${this.hue})`;
	}
	constructor(e, n) {
		this.variableName = n, this.lightness = e.lightness, this.chroma = e.chroma, this.hue = e.hue;
	}
};
function n(n) {
	return new e({
		lightness: 6 * (3 + 1.3 * n) * .01,
		chroma: .001 * (14 + .09 * n),
		hue: 258.36
	}, `--jb-neutral-${n}`);
}
function t(n) {
	return new e({
		lightness: n.lightness + .07,
		chroma: n.chroma + .07,
		hue: n.hue
	}, `${n.variableName}-hover`);
}
function r(n) {
	return new e({
		lightness: n.lightness - .1,
		chroma: n.chroma - .05,
		hue: n.hue
	}, `${n.variableName}-pressed`);
}
function a(n) {
	const t = Math.min(n.lightness + .12 * (1 - n.lightness), .985), r = n.chroma * (1 - .15 * (t - n.lightness));
	return new e({
		lightness: t,
		chroma: Number(r.toFixed(3)),
		hue: n.hue
	}, `${n.variableName}-l`);
}
function i(n) {
	const t = Math.max(n.lightness - .12 * n.lightness, .02);
	return new e({
		lightness: t,
		chroma: n.chroma * (1 - .15 * (t - n.lightness)),
		hue: n.hue
	}, `${n.variableName}-d`);
}
function s(n) {
	const t = Math.min(n.lightness + .65 * (1 - n.lightness), .93), r = .55 * n.chroma * (1 - .08 * (t - n.lightness)), a = n.hue >= 70 && n.hue <= 162 ? 5 : -3, i = n.hue + a;
	return new e({
		lightness: t,
		chroma: Number(r.toFixed(3)),
		hue: i
	}, `${n.variableName}-subtle`);
}
function l(n) {
	const t = Math.max(n.lightness - .35, .22), r = Math.min(1.6 * n.chroma, .28);
	return new e({
		lightness: Number(t.toFixed(3)),
		chroma: Number(r.toFixed(3)),
		hue: n.hue
	}, `${n.variableName}-contrast`);
}
function h(e) {
	return {
		main: e,
		hover: t(e),
		pressed: r(e),
		light: a(e),
		dark: i(e),
		subtle: s(e),
		contrast: l(e)
	};
}
const o = new e({
	lightness: .6,
	chroma: .26,
	hue: 256
}, "--jb-primary"), c = new e({
	lightness: .6,
	chroma: .26,
	hue: 286
}, "--jb-secondary"), u = new e({
	lightness: .75,
	chroma: .18,
	hue: 70
}, "--jb-yellow"), m = new e({
	lightness: .68,
	chroma: .1484,
	hue: 162.1
}, "--jb-green"), g = new e({
	lightness: .6,
	chroma: .22,
	hue: 23.21
}, "--jb-red"), b = {
	single: {
		black: new e({
			lightness: .14,
			chroma: 0,
			hue: 0
		}, "--jb-black"),
		white: new e({
			lightness: 1,
			chroma: 0,
			hue: 0
		}, "--jb-white"),
		highlight: new e({
			lightness: .93,
			chroma: .2302,
			hue: 125.18
		}, "--jb-highlight")
	},
	neutral: [
		n(0),
		n(1),
		n(2),
		n(3),
		n(4),
		n(5),
		n(6),
		n(7),
		n(8),
		n(9),
		n(10)
	],
	primary: h(o),
	secondary: h(c),
	yellow: h(u),
	green: h(m),
	red: h(g)
};
function y(e) {
	try {
		const { value: n, ...t } = e;
		"function" == typeof window.CSS.registerProperty && window.CSS.registerProperty({ ...t }), p(e.name, n);
	} catch (e) {}
}
function p(e, n) {
	try {
		n && (document.documentElement.style.getPropertyValue(e) || document.documentElement.style.setProperty(e, n));
	} catch (e) {}
}
function d(e = "") {
	return crypto?.randomUUID ? `${e}-${crypto.randomUUID()}` : `${e}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
globalThis.HTMLElement;
function v(e, n) {
	y({
		name: n ?? e.variableName ?? `--${d()}`,
		syntax: "<color>",
		inherits: !0,
		initialValue: e.value
	});
}
function x(e) {
	v(e.main), v(e.dark), v(e.light), v(e.contrast), v(e.hover), v(e.pressed), v(e.subtle);
}
function f() {
	w("--jb-content-primary", b.single.black), w("--jb-content-secondary", b.neutral[7]), w("--jb-content-inverse", b.single.white), w("--jb-surface-primary", b.single.white), w("--jb-surface-secondary", b.neutral[10]), w("--jb-surface-inverse", b.single.black);
}
function w(e, n) {
	n.variableName ? p(e, `var(${n.variableName})`) : console.error("Semantic colors must reference a named primitive", n);
}
function j() {
	(function(e) {
		v(e.neutral[0], "--jb-neutral"), x(e.primary), x(e.secondary), x(e.red), x(e.green), x(e.yellow), v(e.single.black), v(e.single.white), v(e.single.highlight);
		for (let n = 1; n <= 10; n++) v(e.neutral[n]);
	})(b), f();
}
function $(e) {
	function n(e) {
		document.documentElement.style.setProperty(e.variableName, e.value);
	}
	function t(e) {
		n(e.main), n(e.light), n(e.dark), n(e.contrast), n(e.subtle), n(e.hover), n(e.pressed);
	}
	e.primary && t(e.primary), e.secondary && t(e.secondary), e.green && t(e.green), e.red && t(e.red), e.yellow && t(e.yellow);
}
function N(n) {
	const t = {};
	return Object.keys(n).forEach((r) => {
		const a = h(new e(n[r], `--jb-${r}`));
		t[r] = a;
	}), t;
}
function V() {
	Object.keys(k).forEach((e) => {
		y({
			name: `--jb-breakpoint-${e}`,
			inherits: !0,
			value: k[e] / 16 + "rem",
			initialValue: `${k[e]}px`,
			syntax: "<length-percentage>"
		});
	}), y({
		name: "--jb-radius",
		inherits: !0,
		value: "1rem",
		initialValue: "16px",
		syntax: "<length-percentage>"
	}), y({
		name: "--jb-radius-xs",
		inherits: !0,
		value: "0.5rem",
		initialValue: "8px",
		syntax: "<length-percentage>"
	}), y({
		name: "--jb-radius-sm",
		inherits: !0,
		value: "0.75rem",
		initialValue: "12px",
		syntax: "<length-percentage>"
	}), y({
		name: "--jb-radius-lg",
		inherits: !0,
		value: "1.25rem",
		initialValue: "20px",
		syntax: "<length-percentage>"
	}), y({
		name: "--jb-radius-xl",
		inherits: !0,
		value: "1.5rem",
		initialValue: "24px",
		syntax: "<length-percentage>"
	}), y({
		name: "--jb-control-height-xs",
		inherits: !0,
		value: "1.5rem",
		initialValue: "24px",
		syntax: "<length-percentage>"
	}), y({
		name: "--jb-control-height-sm",
		inherits: !0,
		value: "2rem",
		initialValue: "32px",
		syntax: "<length-percentage>"
	}), y({
		name: "--jb-control-height-md",
		inherits: !0,
		value: "2.5rem",
		initialValue: "40px",
		syntax: "<length-percentage>"
	}), y({
		name: "--jb-control-height-lg",
		inherits: !0,
		value: "3rem",
		initialValue: "48px",
		syntax: "<length-percentage>"
	}), y({
		name: "--jb-control-height-xl",
		inherits: !0,
		value: "4rem",
		initialValue: "64px",
		syntax: "<length-percentage>"
	});
}
const k = {
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280
};
function M() {
	V(), j();
}
export { e as JBColor, k as breakPoints, h as createColorGroup, N as createThemeColor, b as defaultColors, j as defineColors, V as defineSizes, l as getContrastColor, i as getDarkerColor, t as getHoverColor, a as getLighterColor, n as getNeutralColor, r as getPressedColor, s as getSubtleColor, y as registerCssProperty, M as registerDefaultVariables, $ as setColors, p as setCssProperty };

//# sourceMappingURL=index.js.map